(() => {
  const current = new URL(window.location.href);
  const campaignKeys = /^(utm_(source|medium|campaign|term|content|id)|fbclid|gclid|gbraid|wbraid|msclkid|ttclid)$/i;
  document.querySelectorAll('[data-ve-pdp]').forEach(link => {
    const destination = new URL(link.href, window.location.origin);
    current.searchParams.forEach((value, key) => {
      if (campaignKeys.test(key)) destination.searchParams.set(key, value);
    });
    destination.searchParams.set('vessa_entry', 'birth-control-and-desire');
    destination.searchParams.set('vessa_placement', link.dataset.vePdp);
    link.href = destination.href;
    link.addEventListener('click', () => {
      const detail = { event: 'vessa_advertorial_pdp_click', placement: link.dataset.vePdp, article: 'birth-control-and-desire' };
      if (Array.isArray(window.dataLayer)) window.dataLayer.push(detail);
      window.dispatchEvent(new CustomEvent('vessa:advertorial-click', { detail }));
    });
  });
  document.querySelectorAll('a[href^="#ve-source-"]').forEach(link => {
    link.addEventListener('click', () => {
      const sources = document.querySelector('.ve-sources');
      if (sources) sources.open = true;
    });
  });
  if (window.location.hash.startsWith('#ve-source-')) {
    const sources = document.querySelector('.ve-sources');
    if (sources) sources.open = true;
  }
})();
